import { ColorConfig, PRESET_COLORS, PresetColorKey } from '../types';

const clampRgb = (n: number) => Math.max(0, Math.min(255, n));

export const colorToCss = (config: ColorConfig): string => {
  if (config.mode === 'preset') return PRESET_COLORS[config.presetKey].value;
  return `rgb(${clampRgb(config.r)}, ${clampRgb(config.g)}, ${clampRgb(
    config.b
  )})`;
};

export const makeDefaultColorConfig = (index: number): ColorConfig => {
  const presetKeys = Object.keys(PRESET_COLORS) as PresetColorKey[];
  return { mode: 'preset', presetKey: presetKeys[index % presetKeys.length] };
};
